import { makeAutoObservable } from "mobx";
import { z } from "zod";
import { apiConfigUrl } from "./apiUrl";
import { onError } from "./onError";
import { rest } from "./rest";
import { StompConnection, startStompConnection } from "./stompConnection";

const zObjectModelVersion = z.coerce.number();
const toError = (error: unknown) =>
  error instanceof Error ? error : new Error(String(error));

let connection: StompConnection | null = null;

export const objectModelVersionStore = makeAutoObservable({
  version: null as number | null,
  initialized: false,

  setVersion(version: number | null) {
    this.version = version;
  },

  setInitialized(value: boolean) {
    this.initialized = value;
  },

  disconnect() {
    connection?.stop();
    connection = null;
  },

  clear() {
    this.disconnect();
    this.setVersion(null);
    this.setInitialized(false);
  },

  async loadVersion() {
    const resp = await rest.get(apiConfigUrl("/objectmodelversion"));
    this.setVersion(zObjectModelVersion.parse(resp.data));
  },

  connect() {
    if (!this.initialized) {
      return;
    }

    this.disconnect();

    connection = startStompConnection({
      subscribe: (client) => {
        client.subscribe("/objectmodelversion", (message) => {
          try {
            this.setVersion(zObjectModelVersion.parse(message.body));
          } catch (error) {
            onError(toError(error));
          }
        });
      },
      // Версия, разосланная, пока сокета не было, сама уже не придёт.
      // Без этого URL запросов остаются со старым v= и ответы берутся
      // из HTTP-кэша до F5.
      resync: () => this.loadVersion(),
      onError: (error) => onError(toError(error)),
    });
  },

  async init() {
    if (this.initialized) {
      return;
    }

    this.setInitialized(true);

    try {
      await this.loadVersion();
    } catch (error) {
      onError(toError(error));
    }

    this.connect();
  },
});
